// src/hooks/useUsaDiario.js
// Le ore sulle commesse di questa persona arrivano dal diario «Le mie ore»? (colonna «Ore
// sulle commesse» in Dipendenti, utils/diarioOre.js). Restituisce null finché non si sa.
import { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { usaDiario } from "../utils/diarioOre";

export function useUsaDiario(orgId, uid) {
  const [si, setSi] = useState(null);
  useEffect(() => {
    if (!orgId || !uid) { setSi(false); return undefined; }
    return onSnapshot(query(collection(db, "dipendenti"), where("organizationId", "==", orgId), where("nexoraUid", "==", uid)),
      s => setSi(s.docs.some(d => usaDiario(d.data()))), () => setSi(false));
  }, [orgId, uid]);
  return si;
}
